import { NO_VALUE } from '../../lib/utils';
import { TOKENS } from '../ui/dashboard-primitives';

interface MuscleGroupAvatarProps {
  muscleGroup: string | null | undefined;
  size?: 'sm' | 'md' | 'lg';
}

interface MuscleGroupMeta {
  label: string;
  bg: string;
}

const MUSCLE_MAP: Record<string, MuscleGroupMeta> = {
  chest:     { label: 'CH', bg: TOKENS.amberEmphasis },
  // eslint-disable-next-line no-restricted-syntax -- pre-existing color-literal drift, tracked in docs/refactor-suggestions.md Phase 0/2
  back:      { label: 'BA', bg: 'rgba(245,237,225,0.55)' },
  // eslint-disable-next-line no-restricted-syntax -- pre-existing color-literal drift, tracked in docs/refactor-suggestions.md Phase 0/2
  legs:      { label: 'LE', bg: 'rgba(198,110,77,0.55)'  },
  // eslint-disable-next-line no-restricted-syntax -- pre-existing color-literal drift, tracked in docs/refactor-suggestions.md Phase 0/2
  shoulders: { label: 'SH', bg: 'rgba(232,197,160,0.35)' },
  arms:      { label: 'AR', bg: TOKENS.creamFaint },
  // eslint-disable-next-line no-restricted-syntax -- pre-existing color-literal drift, tracked in docs/refactor-suggestions.md Phase 0/2
  core:      { label: 'CO', bg: 'rgba(198,110,77,0.35)'  },
};

const FALLBACK: MuscleGroupMeta = {
  label: NO_VALUE,
  // eslint-disable-next-line no-restricted-syntax -- pre-existing color-literal drift, tracked in docs/refactor-suggestions.md Phase 0/2
  bg: 'rgba(245,237,225,0.20)',
};

const SIZE: Record<NonNullable<MuscleGroupAvatarProps['size']>, { diameter: number; fontSize: number }> = {
  sm: { diameter: 24, fontSize: 9  },
  md: { diameter: 32, fontSize: 11 },
  lg: { diameter: 40, fontSize: 13 },
};

export function MuscleGroupAvatar({ muscleGroup, size = 'md' }: MuscleGroupAvatarProps) {
  const key = (muscleGroup ?? '').toLowerCase().trim();
  const meta = MUSCLE_MAP[key] ?? FALLBACK;
  const { diameter, fontSize } = SIZE[size];

  return (
    <div
      style={{
        width: diameter,
        height: diameter,
        borderRadius: '50%',
        backgroundColor: meta.bg,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: "'Geist Mono', ui-monospace, 'SF Mono', 'JetBrains Mono', monospace",
        fontWeight: 600,
        fontSize: fontSize,
        letterSpacing: '0.08em',
        // eslint-disable-next-line no-restricted-syntax -- pre-existing color-literal drift, tracked in docs/refactor-suggestions.md Phase 0/2
        color: 'rgba(245,237,225,0.85)',
        flexShrink: 0,
      }}
      aria-label={muscleGroup ?? 'Unknown muscle group'}
    >
      {meta.label}
    </div>
  );
}
